module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8r7n2r5r-f934c5fd9ecb7d06362030f5227b8dfb.svg";